export const MAIN_EVENT = 'event';

export const operationLabel = { check_in: 'Entrada', check_out: 'Saída' };

export const resultLabel = { accepted: 'Aceita', rejected: 'Recusada' };

export const methodLabel = { fixed_qr: 'QR fixo', server_geofence: 'PIN ou QR temporário' };

export const reasonLabel = {
  accepted: 'Presença gravada',
  challenge_required: 'Sem código',
  challenge_expired: 'Código expirado',
  challenge_invalid: 'Código inválido',
  challenge_revoked: 'Código substituído por um novo',
  challenge_mismatch: 'Código de outra atividade ou operação',
  link_not_found: 'QR fixo inexistente',
  link_revoked: 'QR fixo revogado',
  link_day_mismatch: 'QR de outro dia',
  outside_radius: 'Fora da área',
  imprecise_gps: 'GPS impreciso',
  stale_reading: 'Leitura de GPS antiga',
  future_reading: 'Leitura de GPS inválida',
  invalid_coordinates: 'Coordenadas inválidas',
  missing_coordinates: 'Sem localização',
  geofence_not_configured: 'Evento sem área configurada',
  duplicate_check_in: 'Entrada já registrada nesta atividade',
  daily_duplicate_check_in: 'Entrada deste dia já registrada',
  duplicate_check_out: 'Saída já registrada nesta atividade',
  daily_duplicate_check_out: 'Saída deste dia já registrada',
  checkout_without_check_in: 'Saída sem entrada nesta atividade',
  daily_checkout_without_check_in: 'Saída sem entrada neste dia',
  checkout_before_check_in: 'Saída anterior à entrada',
  participation_limit: 'Limite de participantes',
  not_enrolled: 'Sem inscrição',
  activity_not_enrolled: 'Sem inscrição na atividade',
  check_in_too_early: 'Entrada antes da janela',
  check_in_too_late: 'Entrada depois da janela',
  check_out_too_early: 'Saída antes da janela',
  check_out_too_late: 'Saída depois da janela',
  schedule_not_configured: 'Horário não configurado',
  rate_limited: 'Excesso de tentativas',
};

export const activityLabel = (name) => name || 'Evento principal';

const matchesActivity = (subEventId, activity) => {
  if (!activity) return true;
  if (activity === MAIN_EVENT) return subEventId == null;
  return String(subEventId) === String(activity);
};

const matchesText = (values, query) => {
  const needle = String(query || '').trim().toLowerCase();
  if (!needle) return true;
  return values.some((value) => String(value || '').toLowerCase().includes(needle));
};

export function filterPresenceRecords(records, { activity = '', status = '', query = '' } = {}) {
  return (records || []).filter((row) => matchesActivity(row.subEventId, activity)
    && (!status || row.status === status)
    && matchesText([row.nome, row.email], query));
}

export function filterAttempts(attempts, { activity = '', result = '', query = '' } = {}) {
  return (attempts || []).filter((row) => matchesActivity(row.sub_event_id, activity)
    && (!result || row.result === result)
    && matchesText([row.attendee_nome], query));
}

export function presenceSummary(records) {
  const list = records || [];
  return {
    total: list.length,
    complete: list.filter((row) => row.status === 'complete').length,
    checkInOnly: list.filter((row) => row.status === 'check_in_only').length,
    checkOutOnly: list.filter((row) => row.status === 'check_out_only').length,
  };
}
